import { render } from "./ThePatientExpedientMeasuresList.vue?vue&type=template&id=5b089e66&scoped=true&ts=true"
import script from "./ThePatientExpedientMeasuresList.vue?vue&type=script&lang=ts"
export * from "./ThePatientExpedientMeasuresList.vue?vue&type=script&lang=ts"

import "./ThePatientExpedientMeasuresList.vue?vue&type=style&index=0&id=5b089e66&lang=scss&scoped=true"
import "./ThePatientExpedientMeasuresList.vue?vue&type=style&index=1&id=5b089e66&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b089e66"]])

export default __exports__